<template>
    <figure v-lazy-load class="image__wrapper">
        <div
            class="image__placeholder"
            :style="{'height': `${placeholderH}px`, 'width': `${placeholderW}px`}"
        >
            <div class="image__animate"></div>
        </div>
        <img class="image__item" :class="content ? 'content' : ''" :data-url="source" :alt="alt" />
    </figure>
</template>

<script>
export default {
    name: "ImageItem",

    props: {
        source: {
            type: String,
            default: "/img/img-card-plan.jpg"
        },
        alt: {
            type: String,
            required: true,
            default: "image"
        },
        placeholderW: {
            type: Number,
            required: true,
            default: 100
        },
        placeholderH: {
            type: Number,
            required: true,
            default: 100
        },
        content: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style lang="scss">
.image {
    &__placeholder {
        display: inline-block;
        position: absolute;
        background-color: #eee;
    }

    &__animate {
        animation-duration: 1.25s;
        animation-fill-mode: forwards;
        animation-iteration-count: infinite;
        animation-name: placeholderEffect;
        animation-timing-function: linear;
        background: darkgray;
        background: linear-gradient(
            to right,
            #eeeeee 10%,
            #dddddd 18%,
            #eeeeee 33%
        );
        background-size: 800px 104px;
        height: inherit;
        position: relative;
    }

    &__wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        margin-bottom: 0;

        &.loaded {
            .image {
                &__item {
                    visibility: visible;
                    opacity: 1;
                    border: 0;
                }

                &__placeholder {
                    display: none;
                    width: 100%;
                }
            }
        }
    }

    &__item {
        height: inherit;
        width: 100%;
        object-fit: cover;
        border-radius: 4px;
        transition: all 0.4s ease-in-out;
        opacity: 0;
        visibility: hidden;
    }
}

.content {
    width: 100%;
    width: stretch;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
}

@keyframes placeholderEffect {
    0% {
        background-position: -468px 0;
    }
    100% {
        background-position: 468px 0;
    }
}
</style>